<template>
  <div class="home">
   
  </div>
</template>

<script setup>
  import { useRouter } from 'vue-router'
  const router = useRouter()
  router.push('/mall')
</script>
